<template>
  <div class="chart-section">
    <div class="chart-section__inner">
      <svg viewBox="0 0 448 448" class="chart">
        <linearGradient
          id="strokeGradient"
          x1="1"
          y1="0"
          x2="0.2"
          y2="0"
        >
          <stop offset="0" style="stop-color:#f7be01"/>
          <stop offset="1.0" style="stop-color:#178100;"/>
        </linearGradient>
        <circle
          class="chart-ring"
          cx="224"
          cy="224"
          r="210"
          fill="transparent"
          stroke="#eaeaea"
          stroke-width="28"
        ></circle>

        <!-- 달성 정도에 따라 data-per="50" 로 입력 -->
        <circle
          class="chart-segment chart-ring center"
          data-per="50"
          cx="224"
          cy="224"
          r="210"
          fill="transparent"
          stroke-width="28"
          stroke="url(#strokeGradient)"
          stroke-linecap="round"
          :style="{'stroke-dasharray':strokeDashHarry, 
                  'stroke-dashoffset':strokeDashOffset}"
        ></circle>
        <!-- // 달성 정도에 따라 data-per="50" 로 입력 -->
      </svg>

      <div class="box-chart-data">
        <div class="chart-txt">{{title}}<br class="mo" v-if="titleSub"/> {{ titleSub }}</div>
        <div class="chart-data">{{level}}</div>
        <button type="button" class="chart-button" data-layer="aboPromotion" @click="$emit('layer', 'aboPromotion')">달성조건 보기</button>
      </div>

    </div>
    
  </div>
</template>

<script>
export default {
  props: {
    data: { 
      type: Object, 
      default: {persent: 0, level: 0, label: `목표 수`},
      required: true
    }, 
  },
  computed: { 
    strokeDashHarry () {  // 파이차트의 전체의 길이 
      return 2 * Math.PI * 210;
    },
    strokeDashOffset () { // 파이차트의 시작위치 (전체를 덮고 시작점을 끌어오는 방식)
      return this.strokeDashHarry * (1 - (this.persent/100));
    },
    title () { 
      return this.data.label[0] || ''; 
    },
    titleSub () { 
      return this.data.label[1] || ''; 
    }
    ,
    persent () { 
      return this.data.persent;
    },
    level () { 
      return this.data.level;
    }
  }
}
</script>
<style scoped>
@import '../assest/css/abo.css';
</style>



// WEBPACK FOOTER //
// src/views/sales/dashboard3/component/attainment.vue